module.exports = __webpack_public_path__ + "74e7047ef61f641fa5345b36cd06c12b.MP3";